import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TypesModel } from 'common/models/page-models/types/types-data-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { TypesFormWidgetService } from 'common/widget/types/types-form-widget.service';

@Injectable({
    providedIn: 'root'
})
export class TypesFormResolver extends FormResolverService<TypesModel> {
    constructor(
        protected fs: TypesFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}
